import * as React from "react";
const SvgCaretDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.6, d: "M7 10L12 15L17 10H7Z", fill: "#26313F" }));
export default SvgCaretDown;
